export var getEventEmitter = function () { return new Phaser.Events.EventEmitter(); };
export default {
    getEventEmitter: getEventEmitter,
};
